import { Flex, Text } from "@chakra-ui/react";
import { PriceAndStrikePriceLabel } from "./PriceAndStrikePriceLabel";
import { Bundle, Price } from "../../../types";

export interface BundleCardInformationSectionProps {
  content: Bundle;
  priceToUse?: Price;
  discountPercentage?: number;
  showName?: boolean;
  showReleasesPages?: boolean;
  showDescription?: boolean;
  nameNoOfLines?: number;
  namePaddingTop?: string;
  showPrice?: boolean;
}

export function BundleCardInformationSection({
  content,
  priceToUse,
  showName = true,
  showReleasesPages = true,
  showDescription = false,
  nameNoOfLines = 1,
  namePaddingTop,
  showPrice = true,
}: BundleCardInformationSectionProps) {
  const totalReleases = content.total_items;
  const totalPages = content.total_pages;

  return (
    <Flex direction="column" gap={1}>
      {/* Name */}
      {showName && (
        <Text
          variant="cardHeader"
          pt={namePaddingTop}
          noOfLines={nameNoOfLines}
          title={content.display_name}
        >
          {content.display_name}
        </Text>
      )}
      {/* Releases + Pages */}
      {showReleasesPages && (
        <Text fontSize="12px" fontWeight="400" color="neutral.200">
          {totalReleases} release
          {totalReleases > 1 ? "s" : ""} • {totalPages} pages
        </Text>
      )}
      {/* Description */}
      {showDescription && content.description && (
        <Text
          fontSize="14px"
          fontWeight="400"
          color="neutral.200"
          noOfLines={2}
          className="multiline-clamp"
          title={content.description}
        >
          {content.description}
        </Text>
      )}
      {/* Prices */}
      {showPrice && (
        <PriceAndStrikePriceLabel
          price={priceToUse?.display_price_discounted}
          strokePrice={priceToUse?.display_price}
          priceColor="success.500"
          strokeColor="neutral.400"
          fontSize="14px"
        />
      )}
    </Flex>
  );
}
